import { store } from 'store';
import Axios from './Axios';
import { SortOrder, Pagination } from 'utils/sortTable';

export interface MifInError {
  id: number;
  file_name: string;
  date: string;
  error: string;
  equipment: string;
  matricule: string;
}

export interface Response {
  datas: MifInError[];
  total: number;
}

export type Filter = Omit<Partial<MifInError>, 'id'>;

export const fetchMifInError = async (pagination: Pagination, sort: SortOrder, filters: Filter = {}): Promise<Response | undefined> => {
  const jwt = store.getState().auth.token;

  const apiResponse = await Axios<Response>({
    method: 'GET',
    baseURL: process.env.REACT_APP_API_BASE_URL,
    url: '/mif-in-error',
    params: {
      filters,
      pagination,
      sort
    },
    headers: {
      authorization: `bearer ${jwt}`
    }
  }).catch((e) => {
    throw e;
  });

  return apiResponse?.data;
};
